




























































































































































































































import { Component, Ref, Vue } from "vue-property-decorator";
import InfoConfigTargetDialogComponent from "@/components/admin/infoConfig/InfoConfigTargetDialog.vue";
import LiveOperationDialogComponent from "@/components/admin/clients/LiveOperationDialog.vue";
import MiraAllClientsDialogComponent from "@/components/admin/clients/MiraAllClientsDialog.vue";
import ClientStatusDialogComponent from "@/components/admin/clients/ClientStatusDialog.vue";
import ClientMasterDataDialogComponent from "@/components/admin/clients/ClientMasterDataDialog.vue";
import ClientContractsDialogComponent from "@/components/admin/clients/ClientContractsDialog.vue";
import ClientTestSettingsDialogComponent from "@/components/admin/clients/ClientTestSettingsDialog.vue";
import ClientGroupDialogComponent from "@/components/admin/clients/ClientGroupDialog.vue";
import ClientProductsDialogComponent from "@/components/admin/clients/ClientProductsDialog.vue";
import ClientProjectTypesDialogComponent from "@/components/admin/clients/ClientProjectTypesDialog.vue";
import ClientProjectOrganisationDialogComponent from "@/components/admin/clients/ClientProjectOrganisationDialog.vue";
import ClientSystemConfigurationDialogComponent from "@/components/admin/clients/ClientSystemConfigurationDialog.vue";
import ClientAdministrationPartnersComponent from "@/components/admin/clients/ClientAdministrationPartners.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import ClientAdministrationChangesComponent from "@/components/admin/clients/ClientAdministrationChanges.vue";
import { queueClientRowUpdate } from "@/utils/ClientListRowUpdates";
import { markClientDetailStale, takeClientDetailStale } from "@/utils/ClientDetailReloads";
import ContentStateComponent from "@/components/common/ContentState.vue";
import router from "@/router/router";
import { ClientAdministrationDetail, ClientDeviceCounts } from "@/data/models/ClientAdministrationRow";
import {
  getClientDeviceCountsForAdministration,
  getClientForAdministration,
  migrateSharedUsersOfGroup,
  recalculateClientDryings,
} from "@/data/repository/ClientAdministrationRepository";
import { recalculateDryingsErrorSnackbar, recalculateDryingsResultSnackbar } from "@/utils/ClientHelperFunctions";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { CLIENT_LIST_RETURN_PATH_KEY, clientListReturnPath } from "@/utils/ClientAdministrationList";
import { deviceListSelectionForCell, deviceListSelectionToQuery } from "@/utils/ClientDeviceList";
import {
  ARCHIVE_PROJECT_LIST_SELECTION,
  ProjectListOption,
  ProjectStatusOption,
  projectListSelectionToQuery,
} from "@/utils/ClientProjectList";
import { figuresUpdatedAtText } from "@/utils/ClientListFigures";
import { liveOperationChangeText } from "@/utils/ClientLiveOperation";
import { formatDateToDayMonthYear } from "@/utils/DateHelper";
import { DeviceCountAssignmentType } from "@/data/models/ClientAdministrationRow";
import { getValue } from "@/utils/SecureLocalStorage";
import {
  buildClientDetailSections,
  buildClientDeviceCountRows,
  buildClientLicenceRows,
  clientPageTitle,
  ClientLicenceRow,
  clientDetailTitle,
  EMPTY_VALUE,
  ClientDetailField,
  ClientDetailLink,
  ClientDetailSection,
  ClientDeviceCountRow,
} from "@/utils/ClientAdministrationDetail";
import { StatusDialogMode, statusChangeText } from "@/utils/ClientStatus";
import { rememberClientTitle } from "@/utils/ClientAdministrationTitle";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { ComponentName } from "@/utils/RouteGuards";
import { themed } from "@/utils/Theme";
import { formatNumber } from "@/utils/Utils";
import { adminPortalChangeAccess } from "@/permissions/UserPermissions";
import { getReactiveActiveUser } from "@/data/repository/UserRepository";
import { SnackbarModule } from "@/store/modules/SnackbarModule";

/**
 * One client's detail overview in the admin portal, migrated from the IRES Admin Android app's
 * client detail screen: master data, contracts, target versions, status and counts. Read-only.
 *
 * **Not the access boundary.** The route guard hides it without portal membership and
 * `MANAGE_CLIENTS`; the data comes from the `getClientForAdministration` callable, which repeats
 * both checks server-side and returns computed values only.
 *
 * The Android screen's links into the client's users, devices, projects and so on became their own
 * server-checked portal screens instead; acting inside the client itself is "Als Mandant anmelden" on
 * the Mandanten list (#2610069). The per-assignment-type device counts come from their own
 * callable, loaded alongside, because they read every assignment of the client.
 *
 * Addressed by `clientId` in the query. Going back returns to the kept-alive list as it was.
 */
@Component({
  // Explicit, so `<keep-alive :include>` still finds it once the production build minifies class names
  // (ticket 2610019, keepAliveComponentNames.spec.ts).
  name: "ClientAdministrationDetailComponent",
  components: {
    "info-config-target-dialog": InfoConfigTargetDialogComponent,
    "live-operation-dialog": LiveOperationDialogComponent,
    "mira-all-clients-dialog": MiraAllClientsDialogComponent,
    "client-status-dialog": ClientStatusDialogComponent,
    "client-master-data-dialog": ClientMasterDataDialogComponent,
    "client-contracts-dialog": ClientContractsDialogComponent,
    "client-test-settings-dialog": ClientTestSettingsDialogComponent,
    "client-group-dialog": ClientGroupDialogComponent,
    "client-products-dialog": ClientProductsDialogComponent,
    "client-project-types-dialog": ClientProjectTypesDialogComponent,
    "client-project-organisation-dialog": ClientProjectOrganisationDialogComponent,
    "client-system-configuration-dialog": ClientSystemConfigurationDialogComponent,
    "client-administration-partners": ClientAdministrationPartnersComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "client-administration-changes": ClientAdministrationChangesComponent,
    "content-state": ContentStateComponent,
  },
})
export default class ClientAdministrationDetailComponent extends Vue {
  @Ref("infoConfigTargetDialog")
  infoConfigTargetDialog!: InfoConfigTargetDialogComponent;

  @Ref("liveOperationDialog")
  liveOperationDialog!: LiveOperationDialogComponent;

  @Ref("miraAllClientsDialog")
  miraAllClientsDialog!: MiraAllClientsDialogComponent;

  @Ref("statusDialog")
  statusDialog!: ClientStatusDialogComponent;

  @Ref("masterDataDialog")
  masterDataDialog!: ClientMasterDataDialogComponent;

  @Ref("contractsDialog")
  contractsDialog!: ClientContractsDialogComponent;

  @Ref("testSettingsDialog")
  testSettingsDialog!: ClientTestSettingsDialogComponent;

  @Ref("groupDialog")
  groupDialog!: ClientGroupDialogComponent;

  @Ref("productsDialog")
  productsDialog!: ClientProductsDialogComponent;

  @Ref("projectTypesDialog")
  projectTypesDialog!: ClientProjectTypesDialogComponent;

  @Ref("projectOrganisationDialog")
  projectOrganisationDialog!: ClientProjectOrganisationDialogComponent;

  @Ref("systemConfigurationDialog")
  systemConfigurationDialog!: ClientSystemConfigurationDialogComponent;

  @Ref("confirm")
  confirmDialog!: ConfirmationDialogComponent;

  @Ref("changes")
  changesCard!: ClientAdministrationChangesComponent;

  isMigratingSharedUsers = false;
  isRecalculatingDryings = false;

  detail: ClientAdministrationDetail | null = null;
  isLoading = true;
  /** null, "notFound" or "failed". */
  loadError: string | null = null;
  deviceCounts: ClientDeviceCounts | null = null;
  isLoadingDeviceCounts = true;
  deviceCountsError = false;

  /** The shared IRES admin login sees the admin portal read-only (#2610071). */
  get mayEdit(): boolean {
    return adminPortalChangeAccess(getReactiveActiveUser());
  }

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  get clientId(): string {
    const value = this.$route.query.clientId;
    return typeof value === "string" ? value : "";
  }

  get loadErrorText(): string {
    if (this.loadError === null) {
      return "";
    }
    return this.$t(this.loadError === "notFound" ? "admin.clients.detail.notFound" : "admin.clients.detail.loadFailed").toString();
  }

  get title(): string {
    return this.detail ? clientDetailTitle(this.detail) : "";
  }

  get sections(): ClientDetailSection[] {
    if (!this.detail) {
      return [];
    }

    return buildClientDetailSections(
      this.detail,
      (key, values) => this.$t(key, values).toString(),
      (value) => this.formatCount(value),
      figuresUpdatedAtText(this.detail.figuresUpdatedAt ?? null, new Date())
    );
  }

  get deviceCountRows(): ClientDeviceCountRow[] {
    return this.deviceCounts ? buildClientDeviceCountRows(this.deviceCounts, this.formatCount) : [];
  }

  formatCount(value: number): string {
    return formatNumber(value);
  }

  get licenceRows(): ClientLicenceRow[] {
    return buildClientLicenceRows(this.detail?.licences);
  }

  get licenceModelLabel(): string {
    const model = this.detail?.licences?.model;
    return model ? this.$t(`admin.clients.detail.licences.model${model}`).toString() : "";
  }

  get isLicenceExceeded(): boolean {
    return this.licenceRows.some((row) => row.exceeded);
  }

  /** Model 3: "3 von 10", IRES Office's own wording; model 2: the limit alone. */
  licenceValue(row: ClientLicenceRow): string {
    return row.used === null
      ? this.formatCount(row.assigned)
      : this.$t("assignLicences.formatUsage", [this.formatCount(row.used), this.formatCount(row.assigned)]).toString();
  }

  /** The card's number columns, in order, with the device-list column each one opens. */
  get countColumns(): Array<{ field: "panels" | "hyDry" | "slim" | "edge" | "comBoxes" | "minis"; column: "panels" | 0 | 1 | 2 | "comBoxes" | "minis" }> {
    return [
      { field: "panels", column: "panels" },
      { field: "hyDry", column: 0 },
      { field: "slim", column: 1 },
      { field: "edge", column: 2 },
      { field: "comBoxes", column: "comBoxes" },
      { field: "minis", column: "minis" },
    ];
  }

  isOpenableCount(value: string): boolean {
    return value !== EMPTY_VALUE && value !== this.formatCount(0);
  }

  /**
   * Opens the client's device list: for a card number, preset to exactly the devices behind it; for
   * "Alle Geräte" (no cell), unfiltered.
   */
  openDevices(
    column: "panels" | 0 | 1 | 2 | "comBoxes" | "minis" | null,
    rowKey: DeviceCountAssignmentType | "former" | "total" | null
  ) {
    const selection = column !== null && rowKey !== null ? deviceListSelectionForCell(column, rowKey) : [];

    router.push({
      name: ComponentName.CLIENT_ADMINISTRATION_DEVICES,
      query: { clientId: this.clientId, ...deviceListSelectionToQuery(selection) },
    });
  }

  openPdfTemplates() {
    router.push({ name: ComponentName.CLIENT_ADMINISTRATION_PDF_TEMPLATES, query: { clientId: this.clientId } });
  }

  /** Opens the portal screen behind a linked detail value. */
  openLink(link: ClientDetailLink) {
    // The archive's figures open the project list with the archive loaded and the matching status
    // ticked: both together where Cloud serves one archive count, else each its own.
    const archiveSelection: ProjectListOption[] | undefined = {
      archivedProjects: ARCHIVE_PROJECT_LIST_SELECTION,
      oldProjects: [ProjectStatusOption.ARCHIVED],
      deletedProjects: [ProjectStatusOption.DELETED],
    }[link as "archivedProjects" | "oldProjects" | "deletedProjects"];

    if (archiveSelection) {
      router.push({
        name: ComponentName.CLIENT_ADMINISTRATION_PROJECTS,
        query: { clientId: this.clientId, ...projectListSelectionToQuery(archiveSelection) },
      });
      return;
    }

    const name = {
      projects: ComponentName.CLIENT_ADMINISTRATION_PROJECTS,
      reports: ComponentName.CLIENT_ADMINISTRATION_REPORTS,
      users: ComponentName.CLIENT_ADMINISTRATION_USERS,
    }[link as "projects" | "reports" | "users"];

    router.push({ name, query: { clientId: this.clientId } });
  }

  /**
   * Back to the list. It is kept alive and the cache is keyed on the full path, so this returns to
   * the exact address the client was opened from (a cockpit link carries a query), which finds the
   * same instance with its filter, search and rows as they were.
   */
  onBack() {
    const listPath = router.resolve({ name: ComponentName.CLIENT_ADMINISTRATION_LIST }).route.path;
    router.push(clientListReturnPath(getValue(CLIENT_LIST_RETURN_PATH_KEY), listPath));
  }

  updateToolbarTitle() {
    if (this.title) {
      rememberClientTitle(this.clientId, this.title);
    }
    ToolbarContentModule.setToolbarTitle(clientPageTitle(this.$t("admin.clients.title").toString(), this.title));
  }

  /** The client's own Beschreibung target; the detail refreshes in place once it is saved. */
  /** "geändert am 13.10.2026 von Max Muster" under the Betrieb value, when the change is recorded. */
  get liveOperationCaption(): string | null {
    return liveOperationChangeText(
      this.detail?.liveOperation,
      (date) => formatDateToDayMonthYear(date) ?? "",
      (key, values) => this.$t(key, values).toString()
    );
  }

  /**
   * The grey lines under a value: who changed Betrieb or a Status flag last, and the note given with a
   * block or a deletion (#2610067).
   */
  fieldCaptions(field: ClientDetailField): string[] {
    if (field.caption) {
      return [field.caption];
    }
    if (field.action === "liveOperation") {
      return this.liveOperationCaption ? [this.liveOperationCaption] : [];
    }
    if (field.action === "miraAllClients") {
      const caption = liveOperationChangeText(
        this.detail?.miraAllClients,
        (date) => formatDateToDayMonthYear(date) ?? "",
        (key, values) => this.$t(key, values).toString()
      );
      return caption ? [caption] : [];
    }
    const changes = this.detail?.status?.statusChanges;
    const change =
      field.action === "blocked"
        ? changes?.blocked
        : field.action === "active"
        ? changes?.isActive
        : field.labelKey === "admin.clients.detail.fields.deleted"
        ? changes?.deleted
        : null;
    if (!change) {
      return [];
    }
    // The note belongs to the state it explains: a block's note is stale once unblocked.
    const showNote = field.action === "blocked" ? this.detail?.status?.status.blocked === true : field.action !== "active";
    const changedText = statusChangeText(
      change,
      (date) => formatDateToDayMonthYear(date) ?? "",
      (key, values) => this.$t(key, values).toString()
    );
    return [changedText, showNote ? change.note : null].filter((line): line is string => !!line);
  }

  /** Saved, or refused as changed meanwhile: either way the detail refreshes in place; the list row follows a save. */
  async onEditStatus(mode: StatusDialogMode) {
    const status = this.detail?.status;
    if (!status) {
      return;
    }
    const result = await this.statusDialog.show(mode, this.clientId, status.status);
    if (result === null) {
      return;
    }
    if (result !== "CHANGED_MEANWHILE") {
      // What the list's Gesperrt label and its status filters read.
      queueClientRowUpdate(this.clientId, {
        blocked: result.status.blocked,
        isActive: result.status.isActive,
        deleted: result.status.deleted,
      });
    }
    this.refreshAfterSave();
  }

  /** Saved, or refused as changed meanwhile: either way the detail refreshes in place; the list row follows a save. */
  async onEditMasterData() {
    const stored = this.detail?.masterData;
    if (!stored) {
      return;
    }
    const result = await this.masterDataDialog.show(this.clientId, stored, this.detail?.projectNumberPrefix ?? null);
    if (result === null) {
      return;
    }
    if (result !== "CHANGED_MEANWHILE") {
      queueClientRowUpdate(this.clientId, {
        clientName: result.clientName,
        clientNumber: result.clientNumber,
        clientType: result.clientType,
        // The list serves the Kürzel trimmed.
        iresProjectNumberPrefix: result.iresProjectNumberPrefix?.trim() || null,
      });
    }
    this.refreshAfterSave();
  }

  /** Saved, or refused as changed meanwhile: either way the detail refreshes in place; the list row follows a save. */
  async onEditContracts() {
    const stored = this.detail?.contracts;
    if (!stored) {
      return;
    }
    const result = await this.contractsDialog.show(this.clientId, stored);
    if (result === null) {
      return;
    }
    if (result !== "CHANGED_MEANWHILE") {
      // What the list's contract filters and its Servicevertrag column read.
      queueClientRowUpdate(this.clientId, {
        contractTypes: result.contractTypes,
        hasServiceContractForFirmwaresAndConfigs: result.hasServiceContractForFirmwaresAndConfigs,
        hasServiceContractForFirmwaresAndConfigsSince: result.hasServiceContractForFirmwaresAndConfigsSince,
      });
    }
    this.refreshAfterSave();
  }

  /** Saved, or refused as changed meanwhile: either way the detail refreshes in place; the list shows none of it. */
  async onEditTestSettings() {
    const stored = this.detail?.testSettings;
    if (!stored) {
      return;
    }
    if ((await this.testSettingsDialog.show(this.clientId, stored)) !== null) {
      this.refreshAfterSave();
    }
  }

  /**
   * The Gruppe card (#2610074). Saved, or refused as changed meanwhile: the detail refreshes in place; a saved group
   * also tells the kept-alive Mandanten list which rows are masters and members now.
   */
  async onEditGroup() {
    const stored = this.detail?.group;
    if (!stored) {
      return;
    }
    const result = await this.groupDialog.show(this.clientId, stored);
    if (result === null) {
      return;
    }
    if (result !== "CHANGED_MEANWHILE") {
      queueClientRowUpdate(this.clientId, { isMasterClient: result.isMaster });
      const savedIds = result.members.map((member) => member.id);
      savedIds.forEach((id) => queueClientRowUpdate(id, { masterClientId: this.clientId }));
      stored.members
        .filter((member) => !savedIds.includes(member.id))
        .forEach((member) => queueClientRowUpdate(member.id, { masterClientId: null }));
      // Their own Gruppe cards changed too: a kept-alive detail of an added or removed member loads again.
      const storedIds = stored.members.map((member) => member.id);
      savedIds.filter((id) => !storedIds.includes(id)).forEach(markClientDetailStale);
      storedIds.filter((id) => !savedIds.includes(id)).forEach(markClientDetailStale);
    }
    this.refreshAfterSave();
  }

  /**
   * The Produkte card (#2610089 stage 1). Saved, or refused as changed meanwhile: either way the detail
   * reloads (the card and the Verlauf change). The Mandanten list row shows nothing product-related, so
   * no row update is queued.
   */
  async onEditProducts() {
    const stored = this.detail?.products;
    if (!stored) {
      return;
    }
    const result = await this.productsDialog.show(this.clientId, stored);
    if (result === null) {
      return;
    }
    this.refreshAfterSave();
  }

  /**
   * The Projekttypen card (#2610081). Saved, or refused as changed meanwhile: either way the detail
   * refreshes (the card and the Verlauf change). The Mandanten list row shows nothing about types.
   */
  async onEditProjectTypes() {
    const stored = this.detail?.projectTypes;
    if (!stored) {
      return;
    }
    const result = await this.projectTypesDialog.show(this.clientId, stored, this.detail?.group?.isMaster === true);
    if (result === null) {
      return;
    }
    this.refreshAfterSave();
  }

  /**
   * The Projektorganisation card (2026-10-29). Saved, or refused as changed meanwhile: either way the detail
   * refreshes (the card and the Verlauf change). The Mandanten list row shows nothing about it.
   */
  async onEditProjectOrganisation() {
    const stored = this.detail?.projectOrganisation;
    if (!stored) {
      return;
    }
    const result = await this.projectOrganisationDialog.show(this.clientId, stored, this.detail?.group?.isMaster === true);
    if (result === null) {
      return;
    }
    this.refreshAfterSave();
  }

  /**
   * The Systemkonfiguration card (#2610141). Saved, or refused as changed meanwhile: either way the detail
   * refreshes (the card and the Verlauf change).
   */
  async onEditSystemConfiguration() {
    const stored = this.detail?.systemConfiguration;
    if (!stored) {
      return;
    }
    const result = await this.systemConfigurationDialog.show(this.clientId, stored, this.detail?.group?.isMaster === true);
    if (result === null) {
      return;
    }
    this.refreshAfterSave();
  }

  /** "Geteilte Benutzer migrieren" for this MASTER-Mandant, after a confirmation, as MASTER Einstellungen had it. */
  async onMigrateSharedUsers() {
    const confirmed = await this.confirmDialog.show({
      title: this.$t("admin.clients.group.migrateSharedUsers").toString(),
      message: this.$t("admin.clients.group.migrateSharedUsersMessage").toString(),
      acceptMessage: this.$t("admin.clients.group.migrateSharedUsersAccept").toString(),
      rejectMessage: this.$t("common.back").toString(),
    });
    if (!confirmed) {
      return;
    }
    this.isMigratingSharedUsers = true;
    try {
      const migrated = await migrateSharedUsersOfGroup(this.clientId);
      SnackbarModule.showSuccess(
        migrated > 0
          ? { key: "admin.clients.group.migratedSharedUsers", params: [formatNumber(migrated)] }
          : { key: "admin.clients.group.noSharedUsersToMigrate" }
      );
    } catch {
      SnackbarModule.showError({ key: "admin.clients.group.migrateSharedUsersFailed" });
    } finally {
      this.isMigratingSharedUsers = false;
    }
  }

  /**
   * The Hilfsfunktionen card (#2610077): after a confirmation, asks IRES Cloud to recalculate every
   * drying of the client. The result is a snackbar (started / already running = success, nothing to do =
   * error), a refusal an error snackbar by reason; a started run also refreshes the Verlauf card.
   */
  async onRecalculateAllDryings() {
    const confirmed = await this.confirmDialog.show({
      title: this.$t("admin.clients.helperFunctions.recalculateAllDryings.confirmTitle").toString(),
      message: this.$t("admin.clients.helperFunctions.recalculateAllDryings.confirmMessage").toString(),
      acceptMessage: this.$t("admin.clients.helperFunctions.recalculateAllDryings.confirmAccept").toString(),
      rejectMessage: this.$t("common.back").toString(),
    });
    if (!confirmed) {
      return;
    }
    this.isRecalculatingDryings = true;
    try {
      const response = await recalculateClientDryings(this.clientId);
      const snackbar = recalculateDryingsResultSnackbar(response.status);
      if (snackbar.success) {
        SnackbarModule.showSuccess({ key: snackbar.key });
      } else {
        SnackbarModule.showError({ key: snackbar.key });
      }
      // Nothing else on the detail changes: only a started run has a Verlauf row, so only the Verlauf
      // card reads again (Taimoor, 2026-10-20: no reload of the whole page).
      if (response.status === "started") {
        this.changesCard?.reload();
      }
    } catch (error) {
      const snackbar = recalculateDryingsErrorSnackbar(error);
      SnackbarModule.showError(snackbar.params ? { key: snackbar.key, params: snackbar.params } : { key: snackbar.key });
    } finally {
      this.isRecalculatingDryings = false;
    }
  }

  /** Opens another Mandant of the group in its own detail. */
  openClient(clientId: string) {
    router.push({ name: ComponentName.CLIENT_ADMINISTRATION_DETAIL, query: { clientId } });
  }

  async onEditLiveOperation() {
    const liveOperation = this.detail?.liveOperation;
    const currentReason = liveOperation && !liveOperation.live ? liveOperation.reason : null;
    if (await this.liveOperationDialog.show(this.clientId, currentReason)) {
      this.refreshAfterSave();
    }
  }

  /** "Mira: Alle Mandanten" (#2610111); the detail refreshes in place once it is saved. */
  async onEditMiraAllClients() {
    if (await this.miraAllClientsDialog.show(this.clientId, this.detail?.miraAllClients?.enabled ?? false)) {
      this.refreshAfterSave();
    }
  }

  async onEditInfoConfigTarget(effectiveTarget: string) {
    if (await this.infoConfigTargetDialog.show(this.clientId, effectiveTarget === EMPTY_VALUE ? null : effectiveTarget)) {
      this.refreshAfterSave();
    }
  }

  async load() {
    // A fresh load supersedes an outdated mark (a member opened for the first time after the group save).
    takeClientDetailStale(this.clientId);
    // In parallel, not awaited: the counts are the slow half and must not hold up the overview.
    this.loadDeviceCounts();

    this.isLoading = true;
    this.loadError = null;

    try {
      if (this.clientId === "") {
        // A link without a client is the same dead end as a deleted one.
        this.loadError = "notFound";
        this.detail = null;
        return;
      }

      this.detail = await getClientForAdministration(this.clientId);
    } catch (error) {
      // Swallowed on purpose: the screen shows its own failure state (a refusal from Cloud
      // included), and the refresh button is the only useful action.
      const code = (error as { code?: unknown } | null)?.code;
      this.loadError = code === "not-found" || code === "functions/not-found" ? "notFound" : "failed";
      this.detail = null;
    } finally {
      this.isLoading = false;
      this.updateToolbarTitle();
    }
  }

  /**
   * After a save on one of the cards, or a refusal as changed meanwhile: reads the detail again in the
   * background, without the page's loading state, so the page stays where it is and only the values that
   * changed update; the Verlauf card reads its rows again too (Taimoor, 2026-10-20: no full reload after
   * a save). The full {@link load} stays for opening the page and the refresh button.
   */
  async refreshAfterSave() {
    try {
      this.detail = await getClientForAdministration(this.clientId);
      this.updateToolbarTitle();
    } catch {
      // Swallowed on purpose: the page keeps what it showed, the saved change is on the server, and the
      // refresh button reloads on demand.
    }
    this.changesCard?.reload();
  }

  async loadDeviceCounts() {
    this.isLoadingDeviceCounts = true;
    this.deviceCountsError = false;

    try {
      this.deviceCounts = this.clientId === ""
        ? null
        : await getClientDeviceCountsForAdministration(this.clientId);
    } catch {
      // Swallowed on purpose: the card shows its own failure state, and refresh retries it.
      this.deviceCountsError = true;
      this.deviceCounts = null;
    } finally {
      this.isLoadingDeviceCounts = false;
    }
  }

  mounted() {
    this.updateToolbarTitle();
    this.load();
  }

  /**
   * Back from a list it opened (Geräte, Projekte, Berichte, Benutzer): kept alive per client URL, so the
   * detail is shown as it was instead of loading again; only the app bar title needs setting. A group
   * save on its master that added or removed this client marked it outdated: then it loads again.
   */
  activated() {
    this.updateToolbarTitle();
    if (takeClientDetailStale(this.clientId)) {
      this.load();
    }
  }
}
